import { CircleHelp } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "~/components/ui";

interface HelpLabelProps {
  label: string;
  helpKey: string;
}

/** Form label with a translated help tooltip on a question-mark icon. */
export function HelpLabel({ label, helpKey }: HelpLabelProps) {
  const { t } = useTranslation("admin");
  return (
    <div className="inline-flex items-center gap-1">
      {label}
      <Tooltip title={t(helpKey)} placement="top">
        <CircleHelp size={14} className="text-noa-muted cursor-help" />
      </Tooltip>
    </div>
  );
}
